import React, { Component } from 'react';
import PropTypes from 'prop-types';

export class Slide extends Component {
  handleClick = () => {
    const { onClick, index } = this.props;

    onClick(index);
  };

  render() {
    const { index, property, imageSrc } = this.props;

    return (
      <div key={index} onClick={this.handleClick} tabIndex="0">
        <img alt={property} src={imageSrc} />
      </div>
    );
  }
}

Slide.propTypes = {
  imageSrc: PropTypes.string,
  index: PropTypes.number,
  property: PropTypes.string,
  onClick: PropTypes.func
};

export default Slide;
